import type { FunctionViewModel, MeetingOccurrenceViewModel, ReportViewModel } from '@trinnvis/dabih-api-client';
import type { NameEntry } from '../employees/name-entry';
import type { MeetingOccurrence } from './meeting-occurrence';
import { LocalDate } from '../../../utilities/local-date';
import { dateTimeDescription } from '../../utilities';
import type { ContactsAsUsers } from '../partners/contacts-as-users';
import type { MeetingStatus } from '../../../library/lists/meeting-status';
import { meetingParticipantsText } from '../../meetingParticipantsText';

export function toMeetingOccurrenceModel(
  occurrence: MeetingOccurrenceViewModel,
  currentUserId: string,
  reports: ReportViewModel[],
  functions: FunctionViewModel[],
  employeesShortNamesAndI: NameEntry[],
  contactsAsUsers: ContactsAsUsers[],
): MeetingOccurrence {
  let dateTimeForSorting = LocalDate.now().toString();
  if (occurrence.date) {
    dateTimeForSorting = occurrence.date;
    if (occurrence.time) {
      dateTimeForSorting += ' ' + occurrence.time;
    }
  }
  let meetingStatus: MeetingStatus = 'NONE';
  if (occurrence.noticeLastSent) {
    meetingStatus = 'NOTICE_SENT';
  }
  if (
    reports.find((r) => {
      return r.uuid === occurrence.reportUuid;
    }) !== undefined
  ) {
    meetingStatus = 'REPORT_WRITTEN';
  }
  return {
    name: occurrence.name || '',
    uuid: occurrence.uuid,
    isConfirmedEntity: occurrence.isConfirmedEntity,
    date: occurrence.date,
    time: occurrence.time ?? '',
    dateTimeForSorting,
    durationMinutes: occurrence.durationMinutes,
    displayDate: dateTimeDescription(occurrence.date ?? '', occurrence.time ?? '', occurrence.durationMinutes),
    assignees: meetingParticipantsText(occurrence, functions, employeesShortNamesAndI, contactsAsUsers, true),
    classified: occurrence.classification !== 'NONE',
    restricted: occurrence.classification !== 'NONE' && !occurrence.accessControl.includes(currentUserId || ''),
    meetingStatus,
    draftName: occurrence.draftName ?? '',
  };
}
